import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ValidationService } from "src/app/core/validation.service";
import { AlertService } from "src/app/core/alert/alert.service";
import { StorageService } from "src/app/core/helpers/storage.service";
import { MsalService } from 'src/app/core/msal.service';
import { environment } from "../../../../../environments/environment";
import { LanguageService } from "src/app/core/translate/language.service";
import { Validators, FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "src/app/core/auth/auth.service";
import { LoginRequest } from "../interface/authentication";

@Component({
  standalone: false,
  selector: "app-sign-in",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.scss"],
})
export class SignInComponent implements OnInit {
  isProduction: boolean;
  isLogin: boolean;
  isLoading$: boolean = false;
  signInForm = this.formBuilder.nonNullable.group({
    username: ["", Validators.compose([Validators.required])],
    password: ["", Validators.compose([Validators.required])]
  });
  validationMessage: any;
  selectedLang: string = 'en';

  languages = environment.SupportedLanguages;

  constructor(
    private authService: AuthService,
    private router: Router,
    private msal: MsalService,
    public alertService: AlertService,
    public storageService: StorageService,
    public formBuilder: FormBuilder,
    private validationMessages: ValidationService,
    public translate: TranslateService,
    public languageService: LanguageService
  ) {
    this.isProduction = environment.production;
    this.isLogin = false;
    this.validationMessage = this.validationMessages;
    this.translate.addLangs(this.languages);
    this.languageService.language$.subscribe(res => {
      this.selectedLang = res;
      this.translate.setDefaultLang(this.selectedLang);
      this.translate.use(this.selectedLang);
    })
  }
  ngOnInit() {
    this.msal.loadingStatus.subscribe((data) => (this.isLoading$ = data));
    this.isLoading$ = false;
    this.storageService.removeAll();
    this.languageService.saveSelectedLang(this.selectedLang);
  }

  login() {
    this.isLoading$ = true;
    this.msal.microsoftSignIn('sign-in');
  }

  loginWithEmail(userDetails) {
    this.isLogin = true;
    const loginDetails: LoginRequest = {
      username: userDetails.username,
      password: userDetails.password
    }
    this.authService.login(loginDetails).subscribe(
      (res) => {
        this.isLogin = false;
        this.signInForm.reset();
        this.storageService.storeCurrentUser(res);
        this.alertService.success('Login was successful', true);
        this.router.navigate(["user/dashboard"])
      },
      (error) => {
        this.isLogin = false;
        this.alertService.warn(error.error.responseMessage);
      }
    )
  }

  switchLang(event: any) {
    this.selectedLang = event.target.value;
    this.translate.use(this.selectedLang);
    this.languageService.saveSelectedLang(this.selectedLang);
  }

}
